import { HttpParams } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { isNumber } from '@datorama/akita';
import { ConstrainedField } from '@shared/models/constrained-field';
import { ServiceBase, SnackbarFactory } from '@shared/services';
import { Observable, catchError, map, of } from 'rxjs';
import { SelectListItem } from '@shared/models';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-checkbox-list-cell',
  templateUrl: './checkbox-list-cell.component.html',
  styleUrls: ['./checkbox-list-cell.component.scss']
})
export class CheckboxListCellComponent implements OnInit, OnChanges {
  Object = Object;
  @Input() public field!: ConstrainedField;
  @Input() public params!: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
  public selectItems$: Observable<SelectListItem[]>;

  private service = inject(ServiceBase);
  private snackBar = inject(SnackbarFactory);

  toDbModel(rawValue: Record<string | number, boolean>) {
    const readValue = [];

    Object.keys(rawValue).forEach(k => {
      if (rawValue[k] == true) {
        readValue.push(isNumber(k) ? parseInt(k) : k);
      }
    })

    return readValue.join(',');
  }

  public ngOnInit(): void {
    this.setSelectItems();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.params && !changes.params.firstChange) {
      this.setSelectItems();
    }
  }

  setSelectItems() {
    if (this.field.control.enabled) {
      this.field.control.disable({ emitEvent: false });
    }

    this.selectItems$ = this.service
      .getRefSelectList(`selectlist/${this.field.key}`, this.params)
      .pipe(
        catchError((err) => {
          this.snackBar.showButtonSnackbar(err);
          if (this.field.editable) {
            this.field.control.enable({ emitEvent: false });
          }
          return of({ selectItems: [] as SelectListItem[], defaultItem: null });
        }),
        map(({ selectItems, defaultItem }) => {
          if (this.field.editable) {
            this.field.control.enable({ emitEvent: false });
          }

          let selectedItems: string[] = [];

          Object.keys((this.field.control as FormGroup).controls).forEach(control => {
            if ((this.field.control as FormGroup).controls[control].value == true) {
              selectedItems.push(control);
            }
            (this.field.control as FormGroup).removeControl(control, { emitEvent: false });
          });

          selectItems.forEach(item => {
            let checkControl = new FormControl({
              value: selectedItems.includes(item.id.toString()),
              disabled: !this.field.editable,
            });
            (this.field.control as FormGroup).addControl(item.id.toString(), checkControl, { emitEvent: false });
          });

          return selectItems;
        }),
      );
  }
}
